import { useEffect, useRef, useState } from 'react';
import { Portal } from 'react-portal';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import useWindowHeight from 'components/Dashboard/utilities/useWindowHeight';

// Mirrors DateFilterButton's button + portal + scrollbar dropdown shell (Analytics/ui/AnalyticsFilters/FiltersBar.jsx),
// minus the calendar-specific bits, so every engagement-stats filter dropdown looks/behaves the same way.
const FilterDropdownShell = ({ label, children, width, panelWidth = 200, primary }) => {
  const [open, setOpen] = useState(false);
  const [autoHeightMaxValue, setAutoHeightMaxValue] = useState();
  const [dropdownReady, setDropdownReady] = useState(false);
  const filtersElement = useRef(null);
  const optionsContainer = useRef(null);
  const { windowHeight } = useWindowHeight();

  const hideFilters = () => setOpen(false);

  useEffect(() => {
    if (optionsContainer?.current) {
      const remainingSpace = windowHeight - optionsContainer.current.getBoundingClientRect().top;
      const valueToSubstract = remainingSpace > 250 ? 87 : 20;
      setAutoHeightMaxValue(remainingSpace > 200 ? `${remainingSpace - valueToSubstract}px` : `${remainingSpace}px`);
      setDropdownReady(true);
    } else {
      setDropdownReady(false);
    }
  }, [open]);

  const createStyles = () => {
    if (filtersElement.current) {
      const { top, left } = filtersElement.current.getBoundingClientRect();
      // Panel width is independent of the (now auto-width) button - .login-navbar's own stylesheet
      // rule sets min-width: 220px, which would otherwise widen the panel past `panelWidth` if smaller.
      return { position: 'fixed', top: top + 42, left, width: panelWidth, minWidth: panelWidth };
    }
  };

  return (
    <div className='position-relative graph-date-button-container' style={width ? { width } : undefined} ref={filtersElement}>
      <div className='filter-group nowrap-item p-0' style={{ border: primary ? 'none' : undefined }}>
        <button
          className={`general-button filter-item-button specific-x-padding-17 specific-y-padding-6 ${width ? 'w-100' : ''} ${primary ? 'action' : ''}`}
          onClick={() => setOpen(!open)}
        >
          <span
            className={`dropdown-item-element dropdown-item-date-element dropdown-item-element-9 text-truncate ${open ? 'open' : ''}`}
          >
            {label}
          </span>
        </button>
      </div>
      {open && (
        <Portal>
          <div className='general-close-background adjustment-of-position' onClick={hideFilters} />
          <div
            ref={optionsContainer}
            className='login-navbar adjustment-of-position'
            style={{ ...createStyles(), visibility: dropdownReady ? 'visible' : 'hidden' }}
          >
            <CustomScrollbar
              className='simple-scrollbar'
              autoHeight
              autoHeightMin='100%'
              autoHeightMax={autoHeightMaxValue}
            >
              <div className='py-2'>{children({ hideFilters })}</div>
            </CustomScrollbar>
          </div>
        </Portal>
      )}
    </div>
  );
};

export default FilterDropdownShell;
